<template>
    <div class="home-placeholder grid">
        <div class="home-placeholder--wrap">
            <div class="home-placeholder--concentrator">
                <div class="grid--container home-placeholder--container">
                    <div class="grid--row home-placeholder--row">
                        <div class="grid--col home-placeholder--col">
                            <img class="home-placeholder--logo" :src="'img/im_vehi-logo.svg' | static" alt="">
                        </div>
                        <component class="grid--col home-placeholder--col"
                                v-for="(plugin, pluginIdx) in plugins" :key="pluginIdx"
                                :is="plugin.type"
                                :plugin="plugin">
                        </component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import cmsPlaceholderMixin from 'framework/mixins/cms/cms-placeholder/index';


    export default {
        mixins: [
            cmsPlaceholderMixin,
        ],
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/cms-placeholders/home-placeholder/index.vue?1c247724